import React from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';
import ViewApplicantStackedImageCard from './ViewApplicantStackedImageCard';
import { DASHBOARD } from '../../routes/routeConstants';

export interface IPostedJobsCard {
  imgSrc: string;
  title: string;
  description: string;
}

const ViewAllPostedJobsCardHealth: React.FC<IPostedJobsCard> = ({
  imgSrc,
  title,
  description,
}) => {
  return (
    <Container>
      <LeftSection>
        <ImageContainer>
          <Img src={imgSrc} alt="shift location image" />
        </ImageContainer>
        <JobDesc>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </JobDesc>
      </LeftSection>
      <RightSection>
        <StackedImages>
          <ViewApplicantStackedImageCard navUrl={`/${DASHBOARD}`} />
        </StackedImages>
      </RightSection>
    </Container>
  );
};

export default ViewAllPostedJobsCardHealth;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  color: black;
  width: 100%;
  margin: 1rem;
  box-shadow: 0px 20px 26px 0px rgba(186, 182, 182, 0.16);
  border-radius: 0.25rem;
  max-width: 49rem;
`;

const LeftSection = styled.div`
  display: flex;
  width: 60%;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem;
`;

const ImageContainer = styled.div`
  width: 100px;
  height: 100px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  & img {
    width: 100%;
    height: auto;
  }
`;

const JobDesc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 18rem;
`;

const Title = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
`;

const Description = styled.div`
  font-size: 0.872rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;

const RightSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

// const RightImage = styled.div`
//   border-radius: 50%;
//   width: 4rem;
//   height: fit-content;
//   margin-left: -1rem;
//   margin-top: 1rem;
// `;

// const ViewAll = styled.a`
//   margin-top: 5rem;
//   margin-left: -11rem;
// `;

// const LastImage = styled.div`
//   border-radius: 50%;
//   // border: 1px solid red;
//   width: 4rem;
//   height: fit-content;
//   margin-left: -4rem;
//   margin-top: 2rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 1.25rem;
//   font-weight: 400;
//   line-height: normal;
//   color: ${({ theme }) => theme.palette.blackBlackMain};
// `;

// const Linkk = styled(Link)`
//   text-decoration: none;
//   color: #2857d1;
// `;

const StackedImages = styled.div`
  /* border: 1px solid red; */

  @media (max-width: 768px) {
    display: none;
  }
`;
